/**
 * Vérification d'identité récente (socle, 29/10/2026) : avant une action sensible (afficher ou copier un mot de passe
 * sensible du Trousseau…), l'utilisateur se reconnecte à Microsoft Entra dans une petite fenêtre, même si sa session
 * AGORA est ouverte. La preuve vaut DUREE_VERIFICATION_MIN minutes pour sa session, puis il faut recommencer.
 * Détail : docs/TROUSSEAU.md › « Vérification d'identité ».
 */
import { z } from 'zod';

/** Durée de validité d'une vérification réussie (minutes), pour la session AGORA où elle a été faite. */
export const DUREE_VERIFICATION_MIN = 5;
/** Écran public où Entra renvoie la fenêtre de vérification (code + état), qui les transmet à la page AGORA. */
export const ROUTE_VERIFICATION_RETOUR = '/verification/retour';
/** Canal (BroadcastChannel) entre la fenêtre de vérification et la page AGORA qui l'a ouverte (même origine). */
export const CANAL_VERIFICATION = 'agora-verification';

export const schemaRetourVerification = z.object({
  code: z.string().min(1).max(4000),
  etat: z.string().regex(/^[A-Za-z0-9_-]{16,128}$/, 'État de vérification attendu'),
});

export const schemaDebutVerification = z.object({ adresse: z.string() });

export const schemaEtatVerification = z.object({
  /** Application Entra de vérification configurée pour l'environnement. */
  configuree: z.boolean(),
  /** Fin de validité de la dernière vérification de cette session (ISO 8601), ou null. */
  valideJusqua: z.string().nullable(),
});

/** Message posté par la fenêtre de retour sur CANAL_VERIFICATION. */
export const schemaMessageVerification = z.object({
  type: z.literal('retour'),
  code: z.string().optional(),
  etat: z.string().optional(),
  erreur: z.string().optional(),
});

export type RetourVerification = z.infer<typeof schemaRetourVerification>;
export type DebutVerification = z.infer<typeof schemaDebutVerification>;
export type EtatVerification = z.infer<typeof schemaEtatVerification>;
export type MessageVerification = z.infer<typeof schemaMessageVerification>;
